import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { SortDirection } from "@redotech/redo-views-common/table";
import { RedoTableTextCell } from "@redotech/redo-web/arbiter-components/tables/redo-table-cells";
import { ColumnAlignment } from "@redotech/redo-web/table";
import { Column2 } from "@redotech/redo-web/table2";
import { formatDateString } from "../../utils/outbound-labels-utils";

const customDateKeys = [
  "customDate1",
  "customDate2",
  "customDate3",
  "customAttributeDate1",
  "customAttributeDate2",
  "customAttributeDate3",
] as const;

export function CustomDateColumn({
  title,
  key,
}: {
  title: string;
  key: (typeof customDateKeys)[number];
}): Column2<FulfillmentGroupData> {
  return {
    alignment: ColumnAlignment.LEFT,
    key,
    title,
    renderNormalCell: ({ row }: { row: FulfillmentGroupData }) => (
      <RedoTableTextCell
        text={
          row[key]
            ? row[key]
                .map((date) => formatDateString(date.toISOString(), true))
                .join(", ")
            : ""
        }
      />
    ),
    width: 120,
    sort: SortDirection.DESC,
  };
}
